import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription, map } from 'rxjs';

@Directive({
    selector: '[appPhoneNumber]',
    providers: [DecimalPipe],
})
export class PhoneNumberDirective implements OnInit {
    regexStr = '^[0-9]*$';
    private subscription: Subscription;

    constructor(
        private el: ElementRef,
        private ngControl: NgControl,
        private decimal: DecimalPipe
    ) {}

    ngOnInit(): void {
        const control = this.ngControl.control;
        this.subscription = control.valueChanges
            .pipe(
                map((value) => {
                    const numbers = value.replace(/[^0-9]/g, '');
                    if (value.at(-1)?.match(/[\(\))]/)) {
                      return value.slice(0, -2)
                    } else if (numbers.length < 3 && numbers.length) {
                      return  `(${numbers}`
                    } else if (numbers.length < 6 && numbers.length > 2) {
                      return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
                    } else if (numbers.length === 6) {
                      return `(${numbers.slice(0, 3)}) ${numbers.slice(3,6)}`;
                    } else if (numbers.length >= 6) {
                      return `(${numbers.slice(0, 3)}) ${numbers.slice(3,6)}-${numbers.slice(6)}`;
                    } else {
                      return value;
                    }
                    // if (!value.at(-1)?.match(/[\d.]/)) {
                    //     value = value.slice(0, -1);
                    // }
                    // const parts = value.toString().split('.');
                    // parts[0] = this.decimal.transform(
                    //     parts[0].replace(/,/g, '')
                    // );
                    // return parts.join('.');
                })
            )
            .subscribe((v) => {
                control.setValue(v, { emitEvent: false });
            });
    }

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        return new RegExp(this.regexStr).test(event.key);
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.validateFields(event);
    }

    validateFields(event) {
        setTimeout(() => {
            this.el.nativeElement.value = this.el.nativeElement.value.replace(
                /[^0-9]/g,
                ''
            );
            event.preventDefault();
        }, 100);
    }
}
